import exercisesInitialStorage from '../exercises/exercisesInitialStorage';
import getExercises, { parseVariables } from '../_helpers/getExercises';

/**
 * Pre-migration behaviour: changing curriculum clears tag filters, keeps
 * section/subsection/orderBy/userMarks. Checkboxes update immediately.
 */
const setCurriculum = (set, get) => async curriculum => {
  set(state => ({
    ...exercisesInitialStorage,
    section: state.section,
    subsection: state.subsection,
    orderBy: state.orderBy,
    userMarks: state.userMarks,
    curriculum,
    exercises: state.exercises,
    exercisesCount: state.exercisesCount,
    fetched: state.fetched,
    subjectExercisesCount: state.subjectExercisesCount,
  }));
  const variables = parseVariables(get(), { curriculum });
  const exercises = await getExercises(variables);
  const list = exercises?.exercises ?? null;
  set({
    ...exercises,
    exerciseCursor: 0,
    currentExercise: list?.[0] ?? null,
    currentExerciseShape: { t: 0, o: 0, p: 0, a: 0 },
    fileType: 't',
    mark: null,
    allExercisesCompleted: exercises?.allExercisesCompleted ?? false,
  });
};

export default setCurriculum;
